export default __webpack_public_path__ + "static/media/chain-link-fencing-500x500.4828f65d.jpg";